import {observer} from 'mobx-react';
import {t, withState} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {Layout, Panel, Tag, Tooltip} from 'shared/components';
import {InteractiveTable} from 'main/components';
import {InterviewSchedule} from 'main/stores/interview_schedules';
import {InterviewScheduleDirectoryState} from '../state';
import {FormattedMessage} from 'react-intl';

const Name = observer(({model}) => {
  return (
    <div className='flex items-middle'>
      {model.templateName || <FormattedMessage id='recruiting.interview_schedules.Untitled interview schedule'/>}
      {!model.configuredAt && <Tag className='ml1'><FormattedMessage id='recruiting.interview_schedules.Draft'/></Tag>}
      {model.inUse && <Tag colour='grass' className='ml1'><FormattedMessage id='recruiting.interview_schedules.In use'/></Tag>}
      {model.configuredAt && model.integrationsMissing &&
        <Tooltip content={t('recruiting.interview_schedules.MISSING_INTEGRATIONS_TOOLTIP')}>
          <Tag colour='scarlet' className='ml1'><FormattedMessage id='recruiting.interview_schedules.Missing integrations'/></Tag>
        </Tooltip>}
    </div>
  );
});

const COLUMNS = [
  {
    header: 'recruiting.interview_schedules.Name',
    component: Name,
    width: 11
  }
];

const LOCALIZATION = {
  removeModal: {
    header: 'recruiting.interview_schedules.Remove Interview Schedule',
    subHeader: 'recruiting.interview_schedules.Are you sure you want to remove this interview schedule?'
  },
  interactive: {
    addModel: 'recruiting.interview_schedules.New Interview Schedule'
  },
  emptyState: 'recruiting.interview_schedules.No interview schedules to display'
};

const Info = () => {
  return (
    <Panel className='bg-sky border-left--dodger'>
      <Panel.Header title={t('recruiting.interview_schedules.What are interview schedules?')}/>
      <>
        <FormattedMessage id='recruiting.interview_schedules.INFO_PANEL_BODY'/>&nbsp;
        <a
          className='nowrap'
          href='https://support.collage.co/en/articles/15648886-creating-interview-schedules'
          target='_blank'
          rel='noreferrer'>
          <FormattedMessage id='Learn more'/>
        </a>
      </>
    </Panel>
  );
};

const InterviewScheduleDirectoryWithState = observer(({uiState}) => {
  return (
    <Layout>
      <Panel.Stack loose>
        <Info/>
        <InteractiveTable
          uiState={uiState}
          title={t('recruiting.interview_schedules.Interview Schedules')}
          columns={COLUMNS}
          localization={LOCALIZATION}
          onRemove={model => uiState.deleteInterviewSchedule(model)}
          onAdd={() => uiState.createInterviewSchedule()}
          customLinks={model => uiState.customLinksFor(model)}
          editRoute='interview-schedules/:id/edit'
          proxy={{
            type: 'async',
            modelType: types.INTERVIEW_SCHEDULE,
            model: InterviewSchedule,
            endpoint: endpoints.INTERVIEW_SCHEDULES.ALL
          }}
        />
      </Panel.Stack>
    </Layout>
  );
});

export default withState(InterviewScheduleDirectoryWithState, InterviewScheduleDirectoryState);
